export default {
  admin: 'admin.client',
  analyst: 'analyst',
  applicant: 'applicant',
};
